import { Environment, getCurrentEnvironment } from "../featureFlagUtils";

export const getDefinedPresets = (): DefinedPresets => {
  return environmentWiseDetails[getCurrentEnvironment()];
};

export interface DefinedPresets {
  amazonTeamId: string;
}

export const environmentWiseDetails: Record<string, DefinedPresets> = {
  [Environment.Test]: {
    amazonTeamId: "bfe7082a-ef48-45e7-b84e-f06983e5122b",
  },
  [Environment.Alpha]: {
    amazonTeamId: "bfe7082a-ef48-45e7-b84e-f06983e5122b",
  },
  [Environment.Beta]: {
    amazonTeamId: "bf6adc4a-4b9d-4d6d-b314-b9b3ffb1678b",
  },
  [Environment.Gamma]: {
    amazonTeamId: "fbf879b7-a5f9-45b4-a60a-7e915d2b8ff5",
  },
  [Environment.Production]: {
    amazonTeamId: "c27de5c1-7753-479c-8357-099f7ff43bd8",
  },
};
